// extracted by mini-css-extract-plugin
export default {"component":"index_component_H1DMH","alert":"index_alert_XdPjY","component__label-error":"index_component__label-error_dDfxo","component__tabs":"index_component__tabs_oFEre"};